import { Footer as FooterMarkup } from '@/components/ui/layouts/footer/Footer';
import { useContext } from 'react';
import { StaticTextContext } from '../context/StaticTextProvider';

export const Footer = ({ data, language }) => {
  const { st } = useContext(StaticTextContext);

  return (
    <FooterMarkup
      logoData={{
        href: `/${language || ''}`,
        a11yLabel: 'Logo EOI Footer',
      }}
      texts={{
        ubication: st('footer.ubication'),
        contact: st('footer.contact'),
        tel: st('footer.tel'),
        download: st('footer.download'),
        downloadList: st('footer.downloadList'),
        copyright: `© ${new Date().getFullYear()} ${st('footer.copyright')}`,
        location: st('footer.location'),
        a11yLabelNav: st('footer.a11yLabelNav'),
      }}
      contactData={{
        street: st('footer.address'),
        city: st('footer.city'),
        tel: st('footer.phone'),
        mail: st('footer.email'),
        contactWeb: st('footer.contactWeb'),
        contactWebTitle: st('footer.contactWebTitle'),
      }}
      policyData={data?.relations?.LegalMenu?.[0]}
      menuData={data?.relations?.FooterMenu?.[0]}
      logoMenuData={data?.relations?.Partners}
      logoAppData={data?.relations?.Apps}
    />
  );
};
